import Card from 'components/Card';
import { IGrowthEnterprise } from 'interfaces/components/growthEnterprise';
import { RootState, useAppSelector } from 'store';
import { formatThousands } from 'utils/helpers';

const GrowthEnterprise = ({ onUpdate }: IGrowthEnterprise) => {
  const companyInfo = useAppSelector(state => state.companyInfo);
  const selectedChartIndex = useAppSelector(
    (state: RootState) => state.chartsInfo.selectedChartIndex
  );

  const className = 'border-l-4 border-l-green-400';

  return (
    <div className='w-full flex flex-col gap-[10px] pb-6 px-20'>
      <div className='flex gap-6 items-center flex-row justify-between'>
        <Card
          value={
            companyInfo.requiredInfo.yoyARR
              ? `${Math.round(companyInfo.requiredInfo.yoyARR * 100) / 100}%`
              : 'N/A'
          }
          description='ARR Growth'
          onUpdate={onUpdate}
          className={selectedChartIndex === 0 ? className : ''}
        />
        <Card
          value={
            companyInfo.growthAndRetention.netDollarRetention
              ? `${
                  Math.round(
                    companyInfo.growthAndRetention.netDollarRetention * 100
                  ) / 100
                }%`
              : 'N/A'
          }
          description='Net Dollar Retention'
          onUpdate={onUpdate}
          className={selectedChartIndex === 5 ? className : ''}
        />
        <Card
          value={
            companyInfo.requiredInfo.ruleOf40
              ? `${Math.round(companyInfo.requiredInfo.ruleOf40 * 100) / 100}%`
              : companyInfo.requiredInfo.yoyARR &&
                companyInfo.requiredInfo.fcfMargin
              ? `${
                  Math.round(
                    (companyInfo.requiredInfo.yoyARR +
                      companyInfo.requiredInfo.fcfMargin) *
                      100
                  ) / 100
                }%`
              : 'N/A'
          }
          description='Rule of 40'
          onUpdate={onUpdate}
          className={selectedChartIndex === 7 ? className : ''}
        />
        <Card
          value={
            companyInfo.operationalEfficiency.netMagicNumber
              ? `${
                  Math.round(
                    companyInfo.operationalEfficiency.netMagicNumber * 100
                  ) / 100
                }x`
              : 'N/A'
          }
          description='Net Magic Number'
          onUpdate={onUpdate}
          className={selectedChartIndex === 6 ? className : ''}
        />
        <Card
          value={
            companyInfo.requiredInfo.arrPerFTE
              ? `${formatThousands(
                  Math.round(companyInfo.requiredInfo.arrPerFTE * 100) / 100,
                  0
                )}`
              : (companyInfo.requiredInfo.currentARR ||
                  companyInfo.requiredInfo.revenue) &&
                companyInfo.requiredInfo.totalHeadcount
              ? `${formatThousands(
                  (Math.round(
                    (companyInfo.requiredInfo.currentARR ||
                      companyInfo.requiredInfo.revenue ||
                      0) / companyInfo.requiredInfo.totalHeadcount
                  ) *
                    100) /
                    100,
                  0
                )}`
              : 'N/A'
          }
          description='ARR per FTE'
          onUpdate={onUpdate}
          className={selectedChartIndex === 14 ? className : ''}
        />
      </div>
    </div>
  );
};

export default GrowthEnterprise;
